// File: src/Component/common/SelectedEnquiryPopup.js
import React from 'react';
import Button from '../../common/Button/Button';
import Attributes from '../../common/Attributes/Attributes';
import '../../common/selectedPopup.css'; // Assuming you have a CSS file for styling
import EditButton from '../../common/ActionButton/EditButton';

const SelectedEnquiryPopup = ({ selectedEnquiry, closePopup, onEdit }) => {
  if (!selectedEnquiry) return null;

  console.log('SelectedEnquiryPopup selectedEnquiry:', selectedEnquiry);

  // Get the full URL for the attachment
  const getAttachmentUrl = (attachmentPath) => {
    console.log('getAttachmentUrl called with:', attachmentPath);
    console.log('REACT_APP_API_URL:', process.env.REACT_APP_API_URL);
    
    if (!attachmentPath) {
      console.log('No attachment path provided');
      return null;
    }
    
    // If it's already a full URL, return as is
    if (attachmentPath.startsWith('http')) {
      console.log('Full URL detected:', attachmentPath);
      return attachmentPath;
    }
    
    // If it's a relative path, construct the full URL
    const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:3001';
    const fullUrl = `${baseUrl}${attachmentPath}`;
    console.log('Constructed URL:', fullUrl);
    return fullUrl;
  };

  // Debug: Log attachment information
  console.log('Attachment debug info:', {
    hasAttachment: !!selectedEnquiry.attachment,
    attachmentPath: selectedEnquiry.attachment,
    constructedUrl: selectedEnquiry.attachment ? getAttachmentUrl(selectedEnquiry.attachment) : null
  });

  return (
    <div className="popup">
      <div className="popup-content">
        <div className="popup-header">
          <Button onClick={closePopup} className="close-btn top-right" title="Close">×</Button>
        </div>
        <div className="popup-body">
          <div className="popup-grid">
            {/* Enquiry Details Section */}
            <div className="details-section">
              <h4>Enquiry Details</h4>
              <p><strong>Enquiry ID:</strong> {selectedEnquiry.enquiryID || 'N/A'}</p>
              <p><strong>Date:</strong> {selectedEnquiry.date ? new Date(selectedEnquiry.date).toLocaleDateString() : 'N/A'}</p>
              <p><strong>Status:</strong> {selectedEnquiry.status || 'N/A'}</p>
              <p><strong>Category Name:</strong> {selectedEnquiry.Category?.name || 'N/A'}</p>
              <p><strong>Description:</strong> {selectedEnquiry.description || 'N/A'}</p>
              <p><strong>Note:</strong> {selectedEnquiry.note || 'N/A'}</p>
              <p><strong>Attachment:</strong> {selectedEnquiry.attachment ? (
                <a href={getAttachmentUrl(selectedEnquiry.attachment)} target="_blank" rel="noopener noreferrer">View Attachment</a>
              ) : 'N/A'}</p>

            </div>
            {/* Contact Information */}
            <div className="contact-info-section">
              <h4>Contact Information</h4>
              <p><strong>Buyer Name:</strong> {selectedEnquiry.buyerName || 'N/A'}</p>
              <p><strong>Email ID:</strong> {selectedEnquiry.emailID || 'N/A'}</p>
              <p><strong>Phone Number:</strong> {selectedEnquiry.phoneNumber || 'N/A'}</p>
              <p><strong>City:</strong> {selectedEnquiry.city || 'N/A'}</p>
              <p><strong>State:</strong> {selectedEnquiry.state || 'N/A'}</p>

            </div>

            {/* Category Details */}
            {/* <div className="company-details-section">
              <h4>Category Details</h4>
              {selectedEnquiry.Category ? (
                <>
                  <p><strong>Category Name:</strong> {selectedEnquiry.Category.name || 'N/A'}</p>
                  <p><strong>Category Description:</strong> {selectedEnquiry.Category.description || 'N/A'}</p>
                </>
              ) : (
                <p>No category information available.</p>
              )}
            </div> */}

            {/* Attributes Section */}
            <div className="technical-info-section">
              <h4>Attribute Details</h4>
              <Attributes attributes={selectedEnquiry.attributes} />
            </div>

            {/* Enquiries Sent to Sellers */}
            {selectedEnquiry.sellers && selectedEnquiry.sellers.length > 0 && (
              <div className="sellers-section">
                <h4>Enquiry Sent to Sellers</h4>
                <div className="sub-table-container">
                  <table border="1" style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <thead>
                      <tr>
                        <th>Seller ID</th>
                        <th>Seller Name</th>
                        <th>Phone Number</th>
                        <th>Email</th>
                        <th>Company Name</th>
                        <th>Enquiry Send Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedEnquiry.sellers.map((seller, index) => (
                        <tr key={index}>
                          <td>{seller.Seller?.id || ''}</td>
                          <td>{seller.Seller?.firstName || ''} {seller.Seller?.lastName || ''}</td>
                          <td>{seller.Seller?.phoneNumber || ''}</td>
                          <td>{seller.Seller?.emailID || ''}</td>
                          <td>{seller.Seller?.companyName || ''}</td>
                          <td>{seller.createdAt ? new Date(seller.createdAt).toLocaleDateString('en-GB') : ''}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            {/* Enquiries Sent to VCSellers */}
            {selectedEnquiry.VCsellers && selectedEnquiry.VCsellers.length > 0 && (
              <div className="vcsellers-section">
                <h4>Enquiry Sent to VCSellers</h4>
                <div className="sub-table-container">
                  <table border="1" style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <thead>
                      <tr>
                        <th>Seller ID</th>
                        <th>Seller Name</th>
                        <th>Phone Number</th>
                        <th>Email</th>
                        <th>Company Name</th>
                        <th>Enquiry Send Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedEnquiry.VCsellers.map((seller, index) => (
                        <tr key={index}>
                          <td>{seller.vcseller?.id || ''}</td>
                          <td>{seller.vcseller?.firstName || ''} {seller.vcseller?.lastName || ''}</td>
                          <td>{seller.vcseller?.phoneNumber || ''}</td>
                          <td>{seller.vcseller?.emailID || ''}</td>
                          <td>{seller.vcseller?.companyName || ''}</td>
                          <td>{seller.createdAt ? new Date(seller.createdAt).toLocaleDateString('en-GB') : ''}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            {/* Attachment */}
            {/* <div className="response-notes-section">
              <h4>Attachment</h4>
              {selectedEnquiry.attachment ? (
                <a href={getAttachmentUrl(selectedEnquiry.attachment)} target="_blank" rel="noopener noreferrer">View Attachment</a>
              ) : (
                <p>No attachment available.</p>
              )}
            </div> */}
          </div>
        </div>
        <div className="popup-footer">
          <Button onClick={() => onEdit(selectedEnquiry.id || selectedEnquiry.enquiryID)} className="edit-btn" title="Edit Enquiry">Edit</Button>
        </div>
      </div>
    </div>
  );
};

export default SelectedEnquiryPopup;
